<template>
  <div class="modal fade create-new-goal-modal" id="CreateExpenseModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar despesa</h1>
                  <button type="button" class="btn-close create-new-goal-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" @submit.prevent="createExpenseMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar uma nova despesa</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="expense_create" class="form-label fw-medium"
                      >Despesa</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="expense_create"
                      autocomplete="off"
                      placeholder="Exemplo: esmalte"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="expense_value" class="form-label fw-medium"
                      >Valor</label
                    >
                    <input
                      v-model="expense_value"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="expense_value"
                      autocomplete="off"
                      @input="maskMoney"
                      placeholder="Exemplo: 1.150,00"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="recurrence_field" class="form-label">Despesa recorrente ?</label>
                    <select id="recurrence_field" v-model="recurrence" class="form-select">
                      <option value="1" selected>Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label class="form-label">Qual a data da despesa ?</label>
                    <input
                      :disabled="recurrence == true"
                      v-model="recurrence_date"
                      id="basicCalendarExpense"
                      type="text"
                      class="form-control datepicker"
                      placeholder="Selecione a data"
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateExpense" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateExpense">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger create-new-goal-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonCreateExpense" class="btn btn-success">Criar despesa</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import moment from 'moment';

export default {
  name: "CreateExpenseModal",
  data () {
    return {
      expense_value: null,
      recurrence: 1,
      recurrence_date: null
    }
  },
  mounted() {
    flatpickr("#basicCalendarExpense", {
      locale: Portuguese,
      dateFormat: "d/m/Y"
    });
  },
  watch: {
    recurrence(newVal) {
      if(newVal == 1){
        this.recurrence_date = null;
      }
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.expense_value = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.expense_value = value;
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    createExpenseMethod(){
      const alertResponse = this.alertResponse;

      const expense_create = document.getElementById("expense_create").value;
      const expense_value = document.getElementById("expense_value").value;
      const recurrence = this.recurrence;
      const recurrence_date = this.recurrence_date;

      let error = false;

      if(
        expense_create == "" ||
        expense_value == "" ||
        (recurrence == 0 && (recurrence_date == null || recurrence_date == ""))
      ){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      if(expense_create == ""){
        this.$refs.expense_create.style.borderColor = "red";
        error = true;
      }

      if(expense_value == ""){
        this.$refs.expense_value.style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      let rec_date = null;
      if(recurrence_date != null && recurrence_date != ""){
        rec_date = moment(recurrence_date, "DD/MM/YYYY").format("YYYY-MM-DD");
      }

      const objExpenseCreate = {
        "expense": expense_create,
        "value": expense_value,
        "recurrence": recurrence,
        "recurrence_date": rec_date
      }

      const buttonCreateExpense = this.$refs.buttonCreateExpense;
      buttonCreateExpense.disabled = true;
      buttonCreateExpense.innerHTML = "Criando despesa...";
      
      api.axios.post("/api/financial/expense/null/null", objExpenseCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonCreateExpense.innerHTML = "Criar despesa";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && (response.status == 200 || response.status == 201)){
          buttonCreateExpense.innerHTML = "Despesa criada com sucesso !";
          window.location.reload();
        } else {
          buttonCreateExpense.disabled = false;
          buttonCreateExpense.innerHTML = "Criar despesa";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateExpense").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateExpense").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateExpense");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>